module.exports = __webpack_public_path__ + "media/images/background_influencer-c57d315c847ed7002b42f9085b2559fd.jpg";